// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"rb_a bii_sw bii_kx bii_ky","PostDetailRight__brandDaysPosts":"rb_b bii_sw bii_kx bii_ky"};